import { figcaptionWrapper } from './Figcaption.css';

export const FigcaptionWrapper = ({ children }: { children: React.ReactNode }) => {
  return <div className={figcaptionWrapper}>{children}</div>;
};
